@import (reference) '../../constants/spacing.module.less';

.items-table {
  width: 100%;
  border-collapse: collapse;
}

.header-row {
  background-color: var(--default--background-color--14);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
}

.body-row {
  font-size: 14px;
  line-height: 21px;

  border-bottom: 1px solid var(--table--border-color--2);
  border-left: 1px solid var(--table--border-color--2);
  border-right: 1px solid var(--table--border-color--2);
}

.header-cell {
  display: flex;
  align-items: center;

  padding: @space-8;
}

.cell {
  display: flex;
  align-items: center;

  padding: @space-8;
}

.order-number {
  overflow-x: hidden;
}

.input {
  height: 34px;
  width: 100%;
}

.delete-cell {
  width: 47px;
}

.icon-container {
  width: 100%;
  justify-content: center;
}

.delete-button {
  > svg {
    fill: var(--default--icon--fill-color--11);
    width: 16px;

    > path {
      stroke-width: 1px;
    }
  }
}

.read-only-quantity {
  width: 100%;
  justify-content: center;
}

.read-only-unit-price {
  width: 100%;
  justify-content: right;
}

.empty-row-container {
  align-items: center;
  justify-content: center;
  gap: @space-16;
  padding: @space-16 @space-0 @space-0;
}

.empty-row-image {
  display: block;
}

.empty-row-message {
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: var(--default--text-color--16);
  text-align: center;
}
